import { useEffect, useState } from "react";
import { Layout } from "../components/Layout";
import { api } from "../lib/api";
import { AlertTriangle, Clock, TrendingUp, Check } from "lucide-react";
import { cn } from "../lib/utils";
import { toast } from "sonner";

export default function CorporateAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => {
    const params = new URLSearchParams();
    if (filter === "open") params.set("acknowledged", "false");
    if (filter === "ack") params.set("acknowledged", "true");
    api.get(`/alerts?${params.toString()}`).then((r) => setAlerts(r.data));
  };
  useEffect(load, [filter]);

  const ack = async (id) => {
    await api.post(`/alerts/${id}/ack`);
    toast.success("Alert acknowledged");
    load();
  };

  return (
    <Layout variant="corporate">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Corporate</div>
          <h1 className="text-3xl font-bold text-navy">Alerts</h1>
        </div>
        <div className="flex bg-white border border-slate-200 rounded-md p-0.5" data-testid="alert-filter">
          {["all", "open", "ack"].map((f) => (
            <button key={f} onClick={() => setFilter(f)}
                    data-testid={`filter-${f}`}
                    className={cn("px-3 h-8 text-[11px] font-bold uppercase tracking-wider rounded",
                      filter === f ? "bg-navy text-white" : "text-slate-600 hover:text-navy")}>
              {f === "all" ? "All" : f === "open" ? "Open" : "Ack'd"}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-3" data-testid="alerts-list">
        {alerts.map((a) => {
          const toneMap = { high: "border-l-freddy-red bg-freddy-red/5", medium: "border-l-verdict-conditional bg-verdict-conditional/5", low: "border-l-verdict-buy bg-verdict-buy/5" };
          const IconMap = { high: AlertTriangle, medium: Clock, low: TrendingUp };
          const Icon = IconMap[a.severity] || AlertTriangle;
          return (
            <div key={a.alert_id} className={cn("border border-slate-200 border-l-4 rounded-md p-4 flex items-start gap-4", toneMap[a.severity])}>
              <Icon size={18} className="shrink-0 mt-0.5 text-navy" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] uppercase tracking-wider font-bold text-slate-600">{a.alert_type.replace("_", " ")}</span>
                  <span className="text-[10px] text-slate-500 tabular">· {new Date(a.created_at).toLocaleString()}</span>
                </div>
                <div className="font-bold text-navy">{a.title}</div>
                <div className="text-sm text-slate-600 mt-1">{a.message}</div>
              </div>
              {!a.acknowledged_at && (
                <button data-testid={`ack-${a.alert_id}`} onClick={() => ack(a.alert_id)}
                        className="inline-flex items-center gap-1.5 bg-navy hover:bg-navy-800 text-white text-xs font-bold px-3 py-1.5 rounded-md">
                  <Check size={12} /> Ack
                </button>
              )}
              {a.acknowledged_at && <span className="text-[10px] uppercase text-verdict-strongText font-bold">Acknowledged</span>}
            </div>
          );
        })}
        {alerts.length === 0 && <div className="text-sm text-slate-500">No buys flagged yet. Check back after the lanes open.</div>}
      </div>
    </Layout>
  );
}
